import { Button, Grid, MenuItem, Select } from "@mui/material";
import { Add, ArrowBack } from "@mui/icons-material";
import { useEffect, useState } from "react";
import {
  create_booking_dynamic_route,
  get_booking_dynamic_route,
} from "../auth/service";
import { useNavigate } from "react-router-dom";
import CardBookingRoutes from "./routecrads";
import "../MetaTagsAndSeo/metatagseo.css";

// Removed quill-better-table imports

const DynamicRouteList = () => {
  const [getRoutes, setRoutes] = useState([]);

  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/dashboard/bookinglocation/add-dynamic-location-routes");
  };

  const fetchDynamicRoutes = async () => {
    try {
      const data = await get_booking_dynamic_route();
      console.log("fetched dynamioc data", data?.data);
      setRoutes(data?.data || []);
    } catch (e) {
      console.log("error while feching dynamic route", e);
    } finally {
    }
  };

  useEffect(() => {
    fetchDynamicRoutes();
  }, []);

  return (
    <div className="category-add">
      <div className="category-header-container">
        <span className="metaTag-header">List of Dynamic Routes</span>

        <div className="btn-flex">
          <Button
            variant="contained"
            className="bordered-button"
            onClick={handleNavigate}
          >
            ADD BOOKING LOCATION ROUTE
          </Button>
        </div>
      </div>

  

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(3, 1fr)", // 4 columns
          gap: "16px",
        }}
      >
        {getRoutes.map((routename) => (
          <div
            className="category-card-container-application"
            key={routename?._id}
          >
            <CardBookingRoutes
              routename={routename}
              refreshList={fetchDynamicRoutes}
           
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default DynamicRouteList;
